import { AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Box } from '@chakra-ui/react'
import NoteHeader from '../NoteHeader'

interface NoteContainerProps {
  children: JSX.Element
  date: string
  version: string
}

export default function NoteContainer({ children, date, version }: NoteContainerProps) {
  return (
    <AccordionItem bg="bgContent" rounded="md">
      <h2>
        <AccordionButton _hover={{ bg: 'primary.100' }}>
          <Box as="section" id={version} w="full">
            <Box as="span" flex="1" textAlign="left" w="100%">
              <NoteHeader date={date} version={version} />
            </Box>
          </Box>
          <AccordionIcon />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <section id={`#${version}`}>{children}</section>
      </AccordionPanel>
    </AccordionItem>
  )
}
